import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import { apiMiddleware } from 'redux/middleware/Api'
import { loadJson } from "redux/middleware/LoadJson";
import { createReduxHistory, routerMiddleware } from "redux/HistoryContext";
import { rootReducer, RootState } from "redux/reducers/RootReducer";

export function configureStore(initialState?: RootState) {
    // configure middlewares
    const middlewares = [routerMiddleware, apiMiddleware, loadJson];
    // compose enhancers
    const enhancer = compose(applyMiddleware(...middlewares));
    // create store
    const store = createStore(rootReducer, initialState as any, enhancer);
    return { store, history: createReduxHistory(store as any) };
}
